import { useConfig, Plan } from '../context/ConfigContext';

interface PricingCardProps {
  plan: Plan;
  duration: number;
  onSelect: () => void;
  isSelected: boolean;
}

export function PricingCard({ plan, duration, onSelect, isSelected }: PricingCardProps) {
  const { discounts } = useConfig();
  const discount = discounts[duration] || 0;
  const monthlyPrice = plan.priceUsd * (1 - discount);
  const totalPrice = monthlyPrice * duration;

  return (
    <div
      className={`pricing-card ${plan.highlighted ? 'highlighted' : ''} ${isSelected ? 'selected' : ''}`}
      onClick={onSelect}
    >
      {plan.highlighted && <div className="badge">Most Popular</div>}

      <h3 className="plan-name">{plan.name}</h3>
      <p className="plan-description">{plan.description}</p>

      <div className="price-section">
        <span className="price">${monthlyPrice.toFixed(2)}</span>
        <span className="period">/month</span>
      </div>

      {discount > 0 && (
        <div className="discount-badge">
          Save {(discount * 100).toFixed(0)}%
        </div>
      )}

      {duration > 1 && (
        <div className="total-price">
          Total: ${totalPrice.toFixed(2)} for {duration} months
        </div>
      )}

      <ul className="features">
        {plan.features.map((feature, index) => (
          <li key={index}>
            <svg className="check-icon" viewBox="0 0 20 20" fill="currentColor">
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            {feature}
          </li>
        ))}
      </ul>

      <button className={`btn ${isSelected ? 'btn-primary' : 'btn-outline'} btn-full`}>
        {isSelected ? 'Selected' : 'Select Plan'}
      </button>
    </div>
  );
}
